// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, configMultipart, url } from '../../index'
import { debounce } from '@/utils/utils'
import router from '@/router'
import usersApi from '@/api/usersApi'

const state = () => ({
  contract: {
    searchProject: '',
    searchContractor: '',
    files: [],
    deleteFiles: []
  },
  statusOptionList: [],
  statusIntexOptionList: [
    { id: 1, name: 'Исполнитель' },
    { id: 2, name: 'Заказчик' }
  ],
  projectOptionList: [],
  typeOptionList: [],
  assigneeOptionList: [],
  stageOptionList: [],
  contractorOptionList: [],
  debounce: null
})

const getters = {
  getContractForUpdate: state => state.contract,
  getContractStatusList: state => state.statusOptionList,
  getContractStatusIntexList: state => state.statusIntexOptionList,
  getContractProjectList: state => state.projectOptionList,
  getContractAssigneeList: state => state.assigneeOptionList,
  getContractTypeList: state => state.typeOptionList,
  getContractStageList: state => state.stageOptionList,
  getContractContractorList: state => state.contractorOptionList
}

const mutations = {
  SET_DEBOUNCE: (state, debounce) => {
    state.debounce = debounce
  },
  SET_SEARCH_PROJECT: (state, value) => {
    state.contract.searchProject = value || ''
  },
  SET_SEARCH_CONTRACTOR: (state, value) => {
    state.contract.searchContractor = value || ''
  },
  SET_CONTRACT_UPDATE_FILES: (state, value) => {
    state.contract.files = value
  },
  DELETE_CONTRACT_UPDATE_FILE: (state, value) => {
    if (value.id) {
      state.contract.deleteFiles.push(value.id)
    }
  },
  GET_CONTRACT_STATUSES_LIST: (state, status) => {
    state.statusOptionList = status.data.map(status => {
      return {
        ...status
      }
    })
  },
  GET_CONTRACT_PROJECTS_LIST: (state, project) => {
    state.projectOptionList = project.data.map(project => {
      return {
        ...project
      }
    })
  },
  GET_CONTRACT_STAGES_LIST: (state, stage) => {
    state.stageOptionList = stage.data.map(stage => {
      return {
        ...stage
      }
    })
  },
  GET_CONTRACT_ASSIGNEE_LIST: (state, assignee) => {
    state.assigneeOptionList = assignee.map(assignee => {
      return {
        name: assignee.profile.full_name,
        id: assignee.id
      }
    })
  },
  GET_CONTRACT_TYPES_LIST: (state, type) => {
    state.typeOptionList = type.data.map(type => {
      return {
        ...type
      }
    })
  },
  GET_CONTRACT_CONTRACTORS_LIST: (state, contractor) => {
    state.contractorOptionList = contractor.data.map(contractor => {
      return {
        name:
          contractor.long_name +
          (contractor.short_name ? ` (${contractor.short_name})` : ''),
        id: contractor.id
      }
    })
  },
  SET_CONTRACT_UPDATE_INITIAL_STATE: state => {
    state.contract = {
      searchProject: '',
      searchContractor: '',
      files: [],
      deleteFiles: []
    }
  }
}

const actions = {
  contractUpdateSaveInfo ({ state, dispatch }, data) {
    const { actionType } = data

    const newFiles = state.contract.files.filter(e => {
      return e.id === undefined
    })

    const sendNewFiles = function (response) {
      if (newFiles.length > 0) {
        const files = new FormData()
        for (var i = 0; i < newFiles.length; i++) {
          const file = newFiles[i]
          files.append('files[' + i + ']', file)
        }
        axios
          .post(
            `${url}/treaties/${response.data.data.id}/files`,
            files,
            configMultipart
          )
          .then(response => {
            console.log(newFiles)
            console.log('Файлы загрузились!', response)
          })
          .catch(error => {
            console.log('Ошибка обновления файлов', error.response)
          })
      }
    }

    console.log('state.contract.status_intex', state.contract.status_intex)

    const contractData = {
      status_intex_id: data.status_intex?.id,
      amount: data.amount,
      info: data.info,
      worker_id: data.worker?.id,
      project_id: data.project?.id,
      stage_id: data.stage?.id,
      status_id: data.status?.id,
      start_date: data.start_date,
      term: data.term,
      type_id: data.type?.id,
      treaty_number: data.treaty_number,
      partner_id: data.contractor?.id,
      with_nds: data.with_nds
    }

    if (actionType === 'create') {
      if (state.contract.searchProject) {
        axios
          .post(
            `${url}/treaties-project`,
            { name: state.contract.searchProject },
            config
          )
          .then(response => {
            contractData.project_id = response.data.data.id
            axios
              .post(`${url}/treaties`, contractData, config)
              .then(response => {
                router.push({ name: 'ContractList' })
                sendNewFiles(response)
                dispatch('setContractUpdateInitialState')
              })
              .catch(error => {
                console.log('Ошибка обновления договора', error.response)
              })
          })
          .catch(error => {
            console.log('Ошибка добавления проекта:', error)
            console.log('Ошибка добавления проекта:', error.response)
          })
      } else {
        axios
          .post(`${url}/treaties`, contractData, config)
          .then(response => {
            router.push({ name: 'ContractList' })
            sendNewFiles(response)
            dispatch('setContractUpdateInitialState')
          })
          .catch(error => {
            console.log('Ошибка обновления договора', error.response)
          })
      }
    } else {
      if (state.contract.searchProject) {
        axios
          .post(
            `${url}/treaties-project`,
            { name: state.contract.searchProject },
            config
          )
          .then(response => {
            contractData.project_id = response.data.data.id
            axios
              .put(`${url}/treaties/${actionType}`, contractData, config)
              .then(response => {
                router.push({ name: 'ContractList' })

                if (state.contract.deleteFiles.length > 0) {
                  const files = { files: [...state.contract.deleteFiles] }
                  axios
                    .put(
                      `${url}/treaties/${response.data.data.id}/remove-files`,
                      files,
                      config
                    )
                    .then(response => {
                      console.log(response)
                    })
                    .catch(error => {
                      console.log('Ошибка удаления файлов', error.response)
                    })
                }
                sendNewFiles(response)
              })
              .catch(error => {
                console.log('Ошибка обновления договора', error)
              })
          })
          .catch(error => {
            console.log('Ошибка добавления проекта:', error)
            console.log('Ошибка добавления проекта:', error.response)
          })
      } else {
        axios
          .put(`${url}/treaties/${actionType}`, contractData, config)
          .then(response => {
            router.push({ name: 'ContractList' })

            if (state.contract.deleteFiles.length > 0) {
              const files = { files: [...state.contract.deleteFiles] }
              axios
                .put(
                  `${url}/treaties/${response.data.data.id}/remove-files`,
                  files,
                  config
                )
                .then(response => {
                  console.log(response)
                })
                .catch(error => {
                  console.log('Ошибка удаления файлов', error.response)
                })
            }
            sendNewFiles(response)
          })
          .catch(error => {
            console.log('Ошибка обновления договора', error)
          })
      }
    }
  },

  getContractUsers ({ commit }) {
    const params = {
      searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : '',
      currentTake: 10000,
      currentPage: 1
    }
    usersApi
      .getAll(params)
      .then(response => {
        commit('GET_CONTRACT_ASSIGNEE_LIST', response.data.data)
      })
      .catch(error => {
        console.log('ошибка получения юзеров', error)
      })
  },

  getContractAllOptions ({ commit }) {
    const getContractStatusesList = axios.get(`${url}/treaties-status`, config)
    const getContractProjectsList = axios.get(`${url}/treaties-project`, config)
    const getContractStagesList = axios.get(`${url}/treaties-stage`, config)
    const getContractTypesList = axios.get(`${url}/treaties-type`, config)
    const getContractContractorsList = axios.get(`${url}/partner`, config)

    axios
      .all([
        getContractStatusesList,
        getContractProjectsList,
        getContractStagesList,
        getContractTypesList,
        getContractContractorsList
      ])
      .then(
        axios.spread(
          (
            contractStatusListResponse,
            contractProjectListResponse,
            contractStagesListResponse,
            contractTypesListResponse,
            contractContractorsListResponse
          ) => {
            commit(
              'GET_CONTRACT_STATUSES_LIST',
              contractStatusListResponse.data
            )
            commit(
              'GET_CONTRACT_PROJECTS_LIST',
              contractProjectListResponse.data
            )
            commit('GET_CONTRACT_STAGES_LIST', contractStagesListResponse.data)
            commit('GET_CONTRACT_TYPES_LIST', contractTypesListResponse.data)
            commit(
              'GET_CONTRACT_CONTRACTORS_LIST',
              contractContractorsListResponse.data
            )
          }
        )
      )
      .catch(error => {
        console.log(error.response)
        console.log(
          'Ошибка получения списочных данных во время инициализации',
          error
        )
      })
  },

  setContractUpdateInitialState ({ commit }, value) {
    commit('SET_CONTRACT_UPDATE_INITIAL_STATE', value)
  },
  getSearchContractContractorsList ({ commit, state }, value) {
    commit('SET_SEARCH_CONTRACTOR', value)

    if (!state.debounce) {
      commit(
        'SET_DEBOUNCE',
        debounce(function () {
          const params = {
            'search[all]': state.contract.searchContractor
          }

          axios.get(`${url}/partner`, { params, ...config }).then(response => {
            commit('GET_CONTRACT_CONTRACTORS_LIST', response.data)
          })

          commit('SET_DEBOUNCE', null)
        }, 500)
      )

      state.debounce()
    }
  },
  getSearchContractProjectList ({ commit, state }, value) {
    commit('SET_SEARCH_PROJECT', value)

    if (!state.debounce) {
      commit(
        'SET_DEBOUNCE',
        debounce(function () {
          axios
            .get(
              `${url}/treaties-project?expand=treaties&search[all]=${state.contract.searchProject}&take=10&page=1`,
              config
            )
            .then(res => {
              commit('GET_CONTRACT_PROJECTS_LIST', res.data)
            })

          commit('SET_DEBOUNCE', null)
        }, 500)
      )

      state.debounce()
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
